const defaultAddCompanyGroupChange = {};
const addCompanyGroupChange = (state = defaultAddCompanyGroupChange, action) => {
  switch (action.type) {
    case 'ADD_COMPANY_GROUP_CHANGE':
      return {
        ...state,
        ...{ [action.name]: action.value },
      };
    case 'CLEAR_COMPANY_GROUP_CHANGE':
      return {
        ...defaultAddCompanyGroupChange,
      };
    default:
      return state;
  }
};

export default addCompanyGroupChange;
